<div class="main-box" *ngIf="mode === modes.Login">
  <form class="main-form animated fadeIn mt-5" #form="ngForm">
    <div class="text-center mt-4">
      <img src="assets/park-evaluations-logo.svg" alt="Park Evaluations Logo" width="200">
    </div>
    <h1 class="text-center mt-5 title font-weight-normal">Sign In to Park Evaluations</h1>
    <!-- Inputs start -->
    <div class="form-group mt-5">
      <label>Email Address</label>
      <input
        type="email"
        class="form-control"
        name="email" [(ngModel)]="username"
        appValidEmailValidator
        required>
    </div>
    <div class="form-group">
      <label>Password</label>
      <input
        type="password"
        class="form-control"
        name="password"
        [(ngModel)]="password"
        required>
    </div>
    <div class="alert alert-danger" *ngIf="invalidLogin">{{invalidLogin}}</div>
    <!-- Action Buttons -->
    <div class="text-center">
      <!-- canSend, not just requestInProgress: once Firebase has refused the password check
           with its anti-abuse throttle, another attempt is refused too and extends the block
           (Bug 47869). There is no Cancel on this form to reach reset(), so the button stays
           out of service for the life of the screen - the same limitation signup carries. -->
      <button type="submit"
              [disabled]="form.invalid || requestInProgress || !mfa.canSend"
              class="btn btn-primary btn-block btn-lg ut-login-btn"
              (click)="login(form); $event.preventDefault()">
        Login
      </button>
      <button type="button" class="btn btn-link" routerLink="../forgot-password">Forgot Password</button>
    </div>
  </form>
</div>

<div class="main-box" *ngIf="mode === modes.PasswordReset">
  <app-password-reset [code]="oobCode"></app-password-reset>
</div>

<div class="main-box" *ngIf="mode === modes.RevertSecondFactor">
  <app-revert-second-factor [code]="oobCode"></app-revert-second-factor>
</div>

<div class="main-box" *ngIf="mode === modes.Signup">
  <app-signup [user]="user" [token]="token"></app-signup>
</div>

<div class="main-box" *ngIf="mode === modes.MfaChallenge">
  <form class="main-form animated fadeIn mt-5" #mfaForm="ngForm">
    <div class="text-center mt-4">
      <img src="assets/park-evaluations-logo.svg" alt="Park Evaluations Logo" width="200">
    </div>
    <h1 class="text-center mt-5 title font-weight-normal">Two-Factor Authentication</h1>
    <!-- codeReady, not codeSent: a resend retires the previous verification id, so once it
         is gone there is no code the user can still enter - saying one was sent above a
         banner reporting the send failed would be worse than the brief hide. -->
    <p class="text-center mt-3 ut-code-sent" *ngIf="mfa.codeReady">
      A verification code was sent to <strong>{{mfa.phoneHint}}</strong>.
    </p>
    <div class="form-group mt-5">
      <label>Verification Code</label>
      <input
        type="text"
        class="form-control"
        name="verificationCode"
        autocomplete="one-time-code"
        inputmode="numeric"
        [(ngModel)]="mfa.verificationCode"
        required>
    </div>
    <div class="alert alert-danger" *ngIf="mfaError">{{mfaError}}</div>
    <!-- Action Buttons -->
    <div class="text-center">
      <button type="submit"
              [disabled]="mfaForm.invalid || !mfa.codeReady || requestInProgress"
              class="btn btn-primary btn-block btn-lg"
              (click)="verifyMfaCode(mfaForm); $event.preventDefault()">
        Verify
      </button>
      <button type="button"
              class="btn btn-link"
              [disabled]="requestInProgress || !mfa.canResend"
              (click)="resendMfaCode()">{{mfa.resendLabel}}</button>
      <button type="button"
              class="btn btn-link"
              (click)="cancelMfaChallenge()">Back to Login</button>
    </div>
  </form>
</div>

<!-- Outside every mode's *ngIf: the reCAPTCHA host must survive the switch between the
     login form and the challenge, and outlive any one send. -->
<div #recaptchaHost></div>

<div class="py-5"></div>
